import axios from "axios";

if (process.env.NODE_ENV === "development") {
    // urlApi = String(process.env.REACT_APP_DEV_API_URL);
}


export const initializationLogicApi = () => {
    console.log('initializationLogicApi -- start');
    let urlPostAxios = `https://zfcipp-api.demo.logik.io/c`

    let data = {
        "sessionContext": {
            "stateful": true
        },
        "partnerData": {
            "product": {
                "configuredProductId": "01t5f000000pcKbAAI"
            }
        }

    }
    return axios.post(`${urlPostAxios}`, data).then((res) => {
        console.log('initializationLogicApi -- finish');
        console.log(res);
        return data;

    })
}
export const initializationLogicApi1 = () => {
    console.log('initializationLogicApi -- start');
    let urlPostAxios = `https://api.ss-prod.logik.io/admin/fields`


    return axios.post(`${urlPostAxios}`).then((res) => {
        console.log('initializationLogicApi -- finish');
        console.log(res);
        return res;
    })
}

export const prod_logik = () => {
    console.log('initializationLogicApi -- start');
    let urlPostAxios = `https://api.ss-prod.logik.io/admin/fields`

    let data = {
        "sessionContext": {
            "schematicId": 1,
            "stateful": true
        },
        "partnerData": {
            "product": {
                "configuredProductId": "01t5f000000pcKbAAI"
            }
        }

    }
    return axios.post(`${urlPostAxios}`, data).then((res) => {
        console.log('initializationLogicApi -- finish');
        console.log(res);
        return data;
    })
}


export const getConfigurableProducts = () => {
    console.log('eee');

    return axios
        .get("/api/configurableProducts/zip")
        .then((response) => response.data)
        .then((data) => {
            return data;

        })
};
export const updateParams = ({ ...params }) => {

    return axios.post("/api/updateConfig", { params }).then((response) => response.data)
        .then((data) => {
            return data;

        })
};
